import _ from 'common-tools/LodashHelper'
import { FormData, FormValues, FormFieldState, FormState } from './State/ReduxFormState'
import { AppState } from './State/AppStateState'
import { SessionToken, SessionAccount, SessionSettings } from './State/CurrentSessionState'
import { DrawerSizes, DrawerList } from './State/DrawerState'
import { LayoutBreadCrumbKeys } from './State/LayoutState'
import { CurrentRouteInfo, CurrentRouteQueryInfo, IndexRoutes } from './State/ReduxRouterState'

const helperFunctions = {
  SessionToken: SessionToken,
  SessionAccount: SessionAccount,
  SessionSettings: SessionSettings,
  DrawerSizes: DrawerSizes,
  DrawerList: DrawerList,
  CurrentRouteInfo: CurrentRouteInfo,
  CurrentRouteQueryInfo: CurrentRouteQueryInfo,
  // LayoutSearch: LayoutSearch,
  // LayoutMenus: LayoutMenus,
  LayoutBreadCrumbKeys: LayoutBreadCrumbKeys,
  // LayoutNavs: LayoutNavs,
  IndexRoutes: IndexRoutes
}

export const sh = {
  SessionToken: 'SessionToken',
  SessionAccount: 'SessionAccount',
  SessionSettings: 'SessionSettings',
  DrawerSizes: 'DrawerSizes',
  DrawerList: 'DrawerList',
  LayoutSearch: 'LayoutSearch',
  LayoutMenus: 'LayoutMenus',
  LayoutBreadCrumbKeys: 'LayoutBreadCrumbKeys',
  LayoutNavs: 'LayoutNavs',
  CurrentRouteInfo: 'CurrentRouteInfo',
  CurrentRouteQueryInfo: 'CurrentRouteQueryInfo',
  IndexRoutes: 'IndexRoutes',
  FormValues: FormValues,
  FormData: FormData,
  AppState: AppState,
  FormState: FormState,
  FormFieldState: FormFieldState
}

export const buildState = (sh, custom) => {
  return (state) => {
    let stateProps = {}
    if (_.isFunction(custom)) {
      stateProps = _.merge(stateProps, custom(state) || {})
    }
    _.forEach(sh, (h) => {
      if (_.isFunction(h)) {
        let sData = h(state)
        _.forEach(_.keys(sData), (fd) => {
          stateProps[fd] = sData[fd]
        })
      } else {
        stateProps[h] = helperFunctions[h](state)
      }
    })
    return stateProps
  }
}
